import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Login } from './Login';
import { MainLayout } from './layout/MainLayout';
import { PedidosPage } from '../modules/pedidos/pages/PedidosPage';
import { NovoPedidoPage } from '../modules/pedidos/pages/NovoPedidoPage';
import { PedidoDetailPage } from '../modules/pedidos/pages/PedidoDetailPage';
import { EditarPedidoPage } from '../modules/pedidos/pages/EditarPedidoPage';
import { ClientesList } from '../pages/ClientesList';
import { VisitasList } from '../pages/VisitasList';
import { MapaPage } from '../modules/visitas/pages/MapaPage';
import { AgendaPage } from '../modules/visitas/pages/AgendaPage';
import { HistoricoVisitasPage } from '../modules/visitas/pages/HistoricoVisitasPage';
import { LeadsList } from '../pages/LeadsList';
import { Atividades } from '../pages/Atividades';
import { RelatorioVendas } from '../modules/reports/RelatorioVendas';
import { RelatorioCRM } from '../modules/reports/RelatorioCRM';
import { RelatorioVisitas } from '../modules/reports/RelatorioVisitas';
import { DashboardDispatcher } from '../modules/dashboards/DashboardDispatcher';
import { UsuariosPage } from '../modules/admin/pages/UsuariosPage';
import { PoliticasGlobaisPage } from '../modules/admin/pages/PoliticasGlobaisPage';
import { VendedorConfigPage } from '../modules/admin/pages/VendedorConfigPage';
import { GerenciarFotosPage } from '../modules/admin/pages/GerenciarFotosPage';

/**
 * Componente principal de rotas
 * AIDEV-NOTE: Árvore única de <Routes> para evitar conflitos de roteamento.
 * Anteriormente havia duas árvores paralelas (PrivateRoutes + PublicRoutes)
 * renderizadas simultaneamente, causando matching ambíguo de rotas.
 */
export function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <p>Carregando...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout>
            <DashboardDispatcher />
          </MainLayout>
        }
      />
      <Route
        path="/pedidos"
        element={
          <MainLayout>
            <PedidosPage />
          </MainLayout>
        }
      />
      {/* AIDEV-NOTE: /pedidos/novo DEVE vir antes de /pedidos/:id para evitar match com :id="novo" */}
      <Route
        path="/pedidos/novo"
        element={
          <MainLayout>
            <NovoPedidoPage />
          </MainLayout>
        }
      />
      {/* AIDEV-NOTE: /pedidos/:id/editar DEVE vir antes de /pedidos/:id para evitar match ambiguo */}
      <Route
        path="/pedidos/:id/editar"
        element={
          <MainLayout>
            <EditarPedidoPage />
          </MainLayout>
        }
      />
      <Route
        path="/pedidos/:id"
        element={
          <MainLayout>
            <PedidoDetailPage />
          </MainLayout>
        }
      />
      <Route
        path="/clientes"
        element={
          <MainLayout>
            <ClientesList />
          </MainLayout>
        }
      />
      <Route
        path="/visitas"
        element={
          <MainLayout>
            <VisitasList />
          </MainLayout>
        }
      />
      <Route
        path="/visitas/agenda"
        element={
          <MainLayout>
            <AgendaPage />
          </MainLayout>
        }
      />
      <Route
        path="/visitas/historico"
        element={
          <MainLayout>
            <HistoricoVisitasPage />
          </MainLayout>
        }
      />
      <Route
        path="/mapa"
        element={
          <MainLayout>
            <MapaPage />
          </MainLayout>
        }
      />
      <Route
        path="/leads"
        element={
          <MainLayout>
            <LeadsList />
          </MainLayout>
        }
      />
      <Route
        path="/atividades"
        element={
          <MainLayout>
            <Atividades />
          </MainLayout>
        }
      />
      <Route
        path="/relatorios/vendas"
        element={
          <MainLayout>
            <RelatorioVendas />
          </MainLayout>
        }
      />
      <Route
        path="/relatorios/crm"
        element={
          <MainLayout>
            <RelatorioCRM />
          </MainLayout>
        }
      />
      <Route
        path="/relatorios/visitas"
        element={
          <MainLayout>
            <RelatorioVisitas />
          </MainLayout>
        }
      />
      <Route
        path="/dashboard"
        element={
          <MainLayout>
            <DashboardDispatcher />
          </MainLayout>
        }
      />
      {/* Admin routes — only accessible to admin profile users */}
      <Route
        path="/admin/usuarios"
        element={
          <MainLayout>
            <UsuariosPage />
          </MainLayout>
        }
      />
      <Route
        path="/admin/politicas"
        element={
          <MainLayout>
            <PoliticasGlobaisPage />
          </MainLayout>
        }
      />
      <Route
        path="/admin/vendedores/:id"
        element={
          <MainLayout>
            <VendedorConfigPage />
          </MainLayout>
        }
      />
      <Route
        path="/admin/catalogo"
        element={
          <MainLayout>
            <GerenciarFotosPage />
          </MainLayout>
        }
      />
      <Route
        path="/admin/produtos/:codigo/fotos"
        element={
          <MainLayout>
            <GerenciarFotosPage />
          </MainLayout>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
